/*
 * @file: index.js
 * @description: It Contain user related Action Creators.
 * @author: navreet
 */

import * as TYPE from '../constants'
import ApiClient from '../../api-client'
import { apiUrl, apiUrlMerchant } from '../../environment'
import { toastAction } from '../toast-actions'

export const is_fetching = (status) => ({ type: TYPE.IS_FETCHING, status })

export const logout_user = () => ({ type: TYPE.LOG_OUT })
export const admin_list = (data, res) => ({ type: TYPE.ADMIN_LIST, data, res })
export const errorUpdate = (data, message) => ({ type: TYPE.ERROR_STATUS, data, message })
export const updateSelectedAdminId = (data) => ({ type: TYPE.UPDATE_SELECTED_ADMIN_ID, data })


//**** Thunk Action Creators For Api ****//
/****** action get listing ********/
export const userListing = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrl}/adminList`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(admin_list(response.data, response))
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}

/****** action creator for delete User ********/
export const deleteUsers = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.delete(`${apiUrl}/adminAccountDeleteByID`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for update User ********/
export const updateUserStatus = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrl}/adminUpdateUser`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}
/****** action creator for change password ********/
export const changePasswordSubAdmin = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrl}/updatePassword`, params, token).then((response) => {
            if (response.customcode === 200) {
                // dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}

/****** action creator for add User ********/
export const addAdmin = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrl}/createAdmin`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
} /****** action creator for edit User ********/
export const editAdmin = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrl}/UpdateAdmin`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(is_fetching(false))

                dispatch(logout_user())
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}
/****** action creator for logout ********/
export const logout = (token, callback) => {
    return (dispatch) => {
        //dispatch(is_fetching(true));
        //ApiClient.delete(`${apiUrl}/user/logout`, token).then(response => {
        //  if (response.statusCode === 200) {
        //    dispatch(is_fetching(false));
        dispatch(logout_user())
        callback(true)
        //  } else {
        //    dispatch(is_fetching(false));
        //    toastAction(false, response.msg);
        //    callback(true);
        //  }
        //});
    }
}

/****** action for restore ********/
export const restoreAdmin = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))

        // Make API request to restore admin
        ApiClient.put(`${apiUrl}/restoreAdmin`, params, token)
            .then((response) => {
                if (response.customcode === 200) {
                    dispatch(is_fetching(false))
                    callback(true)
                } else if (response.customcode === 401) {
                    dispatch(is_fetching(false))

                    dispatch(logout_user())
                    callback(false)
                } else {
                    dispatch(is_fetching(false))
                    dispatch(errorUpdate(true, response.message))
                    callback(false)
                }
            })
            .catch((error) => {
                dispatch({ payload: error.message });
                callback(false);
            });
    };
};